export default {
      id: "money copy-usage",
      viewBox: "0 0 41 40",
      url: __webpack_public_path__ + "img/icons.e22fd14f.svg#money copy",
      toString: function () {
        return this.url;
      }
    }